import apiClient from 'boot/ApiClient'

export const sessionInit = ({ commit, dispatch, getters }) => {
//  console.trace()
  if (getters['isInited']) {
    return true
  }
  return new Promise((resolve, reject) => {
    apiClient.get('/api/security/sessionInit')
      .then(response => {
        if (response.data && response.data.success && response.data.success === true &&
          response.data.username && response.data.username !== '') {
          // van működő session
          commit('INIT')
          commit('ONLINE')
          dispatch('security/loggedInUserChanged', '', { root: true })
          resolve(response)
        } else {
          // van Internet de nincs session
          commit('INIT')
          commit('ONLINE')
          resolve(response)
        }
      })
      .catch(err => {
        commit('INIT')
        commit('OFFLINE')
        reject(err)
      })
  })
}
